var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-listado',[_c('page-header',{attrs:{"title":"Planes"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm","to":"/planes/crear"}},[_c('v-icon',{attrs:{"name":"plus","width":"16"}}),_vm._v(" Crear plan ")],1)],1),_c('tabla',{attrs:{"planes":_vm.planes},on:{"eliminar":_vm.eliminar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }